
import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useChatWidget } from "@/hooks/useChatWidget";
import { ChatWidgetHeader } from "@/components/chat/ChatWidgetHeader";
import { ChatWidgetMessages } from "@/components/chat/ChatWidgetMessages";
import { ChatWidgetInput } from "@/components/chat/ChatWidgetInput";
import { useTheme } from "@/components/theme-provider";
import { useLocation } from "react-router-dom";

export function ChatWidget() {
  // SSR handling is now managed by ClientOnlyChatWidget wrapper
  
  const {
    isOpen,
    messages,
    inputValue,
    isLoading,
    scrollAreaRef,
    setInputValue,
    toggleWidget,
    handleSendMessage,
    handleKeyDown,
    waitingMessages,
    isShowingWaitingMessages,
    waitingMessageCategory
  } = useChatWidget();
  
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const location = useLocation();
  
  // Don't show the chat widget if we're already on the Gildy chat page
  const isGildyPage = location.pathname === "/gildy";
  
  // If we're on the Gildy page, don't render the widget at all
  if (isGildyPage) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen ? (
        <Card className="flex flex-col w-[350px] h-[450px] shadow-xl overflow-hidden">
          <ChatWidgetHeader onClose={toggleWidget} />
          
          <ChatWidgetMessages 
            messages={messages} 
            isLoading={isLoading} 
            scrollAreaRef={scrollAreaRef}
            waitingMessages={waitingMessages}
            isShowingWaitingMessages={isShowingWaitingMessages}
            waitingMessageCategory={waitingMessageCategory}
          />
          
          <ChatWidgetInput 
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onSend={handleSendMessage}
            isLoading={isLoading}
          />
        </Card>
      ) : (
        <Button 
          onClick={toggleWidget} 
          size="icon" 
          className="h-14 w-14 rounded-full shadow-lg bg-gold hover:bg-gold-dark transition-colors"
          aria-label="Apri chat assistente"
          data-testid="chat-button"
        >
          <MessageCircle className="h-6 w-6 text-white" strokeWidth={2.5} />
        </Button>
      )}
    </div>
  );
}
